import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCircleToolSmart = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			opacity: .6,
			x: 5,
			y: 5,
			width: 22,
			height: 22,
			rx: 11,
			fill: "#7F64FF"
		}),
		/* @__PURE__ */ _jsx("g", {
			filter: "url(#filter0_d)",
			children: /* @__PURE__ */ _jsx("path", {
				d: "M15.3223 13.0646C15.4599 12.2393 15.5286 11.8267 15.6142 11.7231C15.8142 11.4809 16.1853 11.4809 16.3853 11.7231C16.4709 11.8267 16.5396 12.2393 16.6772 13.0646C16.7612 13.5685 16.8032 13.8205 16.8931 14.0351C17.0959 14.5191 17.4808 14.9039 17.9647 15.1067C18.1793 15.1967 18.4313 15.2387 18.9352 15.3226C19.7605 15.4602 20.1731 15.529 20.2767 15.6145C20.5189 15.8145 20.5189 16.1856 20.2767 16.3856C20.1731 16.4712 19.7605 16.5399 18.9352 16.6775C18.4313 16.7615 18.1793 16.8035 17.9647 16.8934C17.4808 17.0962 17.0959 17.4811 16.8931 17.965C16.8032 18.1796 16.7612 18.4316 16.6772 18.9355C16.5396 19.7608 16.4709 20.1734 16.3853 20.277C16.1853 20.5192 15.8142 20.5192 15.6142 20.277C15.5286 20.1734 15.4599 19.7608 15.3223 18.9355C15.2383 18.4316 15.1964 18.1796 15.1064 17.965C14.9036 17.4811 14.5188 17.0962 14.0348 16.8934C13.8202 16.8035 13.5682 16.7615 13.0643 16.6775C12.239 16.5399 11.8264 16.4712 11.7228 16.3856C11.4806 16.1856 11.4806 15.8145 11.7228 15.6145C11.8264 15.529 12.239 15.4602 13.0643 15.3226C13.5682 15.2387 13.8202 15.1967 14.0348 15.1067C14.5188 14.9039 14.9036 14.5191 15.1064 14.0351C15.1964 13.8205 15.2383 13.5685 15.3223 13.0646Z",
				fill: "#5531FF"
			})
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("filter", {
			id: "filter0_d",
			x: 8.54102,
			y: 9.54144,
			width: 14.9172,
			height: 14.9172,
			filterUnits: "userSpaceOnUse",
			colorInterpolationFilters: "sRGB",
			children: [
				/* @__PURE__ */ _jsx("feFlood", {
					floodOpacity: 0,
					result: "BackgroundImageFix"
				}),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					in: "SourceAlpha",
					type: "matrix",
					values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
					result: "hardAlpha"
				}),
				/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
				/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
				/* @__PURE__ */ _jsx("feColorMatrix", {
					type: "matrix",
					values: "0 0 0 0 0.333333 0 0 0 0 0.192157 0 0 0 0 1 0 0 0 0.6 0"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in2: "BackgroundImageFix",
					result: "effect1_dropShadow"
				}),
				/* @__PURE__ */ _jsx("feBlend", {
					mode: "normal",
					in: "SourceGraphic",
					in2: "effect1_dropShadow",
					result: "shape"
				})
			]
		}) })
	]
});
const ForwardRef = forwardRef(SvgCircleToolSmart);
export { ForwardRef as ReactComponent };
